const pageNameKey = "disconnectedGatewaysListContainer";

export const disconnectedGatewaysListContainerEn = {
  [pageNameKey]: { description: "Disconnected Gateways" },
};

export const disconnectedGatewaysListContainerPtBr = {
  [pageNameKey]: { description: "Gateways desconectados" },
};

export const disconnectedGatewaysListContainerDe = {
  [pageNameKey]: { description: "Getrennte Gateways" },
};

export const disconnectedGatewaysListContainerZhHans = {
  [pageNameKey]: {
    description: "已断开连接的网关",
  },
};

export const disconnectedGatewaysListContainerIt = {
  [pageNameKey]: { description: "Gateway disconnessi" },
};

export const disconnectedGatewaysListContainerEs = {
  [pageNameKey]: { description: "Gateways desconectados" },
};

export const disconnectedGatewaysListContainerNl = {
  [pageNameKey]: {
    description: "Verbroken gateways",
  },
};

export const disconnectedGatewaysListContainerTr = {
  [pageNameKey]: {
    description: "Bağlantısı Kesilmiş Ağ Geçitleri",
  },
};
